/** App-wide Roboto font stacks (mobile view). */
export const FONT_ROBOTO = "Roboto, sans-serif";
export const FONT_ROBOTO_MONO = "Roboto Mono, monospace";
